module.exports = {
	startCarousel: function () {
		$('.carousel').each(function () {
			var $win = $(window)
			var $wrapper = $(this)
			var $carousel = $wrapper.children('ul')
			var $clones = $carousel
				.children()
				.clone()
				.css('display', 'none')
				.addClass('is-clone')
				.appendTo($carousel)

			var speed = $wrapper.data('speed') || 1000
			var duration = $carousel.children(':not(.is-clone)').length * speed
			var scroll = $carousel.prop('scrollWidth')

			var resizeTimer
			$win
				.on('resize.carousel', function () {
					if (resizeTimer) clearTimeout(resizeTimer)
					resizeTimer = setTimeout(resize, 200)
				})
				.on('load', resize)

			function resize() {
				$wrapper.stop()
				$clones.css('display', 'none')
				scroll = $carousel.prop('scrollWidth')
				if (scroll > window.innerWidth) {
					$clones.css('display', '')
					animate()
				}
			}

			if ($wrapper.data('pause-on-hover') != false) {
				$wrapper.on({
					mouseleave: function () {
						$wrapper.queue(animate)
					},
					mouseenter: function () {
						$wrapper.clearQueue().stop()
					}
				})
			}

			$wrapper
				.on('click', '.carousel-next', function () {
					var dist = $wrapper.outerWidth() / 2
					$wrapper.stop().animate({
						scrollLeft: '+=' + dist
					}, 300, function () {
						var progress = $wrapper.scrollLeft()
						if (progress >= scroll) $wrapper.scrollLeft(progress - scroll)
					})
				})
				.on('click', '.carousel-prev', function () {
					var dist = $wrapper.outerWidth() / 2
					var progress = $wrapper.scrollLeft()
					if (progress <= dist) $wrapper.scrollLeft(scroll + progress)
					$wrapper.stop().animate({
						scrollLeft: '-=' + dist
					}, 300)
				})

			function animate() {
				$wrapper.stop()
				var p = $wrapper.scrollLeft() / scroll
				var d = duration - duration * p
				$wrapper.animate({
						scrollLeft: scroll
					},
					d,
					'linear',
					function () {
						$wrapper.scrollLeft(0)
						animate()
					}
				)
			}
		})
	},

	debounce: function debounce(func, wait, immediate) {
		var timeout
		return function () {
			var context = this,
				args = arguments
			var later = function () {
				timeout = null
				if (!immediate) func.apply(context, args)
			}
			var callNow = immediate && !timeout
			clearTimeout(timeout)
			timeout = setTimeout(later, wait)
			if (callNow) func.apply(context, args)
		}
	}

}